import { Content } from '@tiptap/core'

import { EditorText } from '../../EditorText'
import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type CommentProps = BaseNotificationItemProps & {
  userName: string
  message: string
  origin: 'engagement' | 'task'
  type: 'comment'
}

export function Comments({ userName, origin, message, ...props }: CommentProps) {
  const originText = origin === 'engagement' ? 'an engagement' : 'a task'

  return (
    <NotificationItem
      {...props}
      title={`${userName} left a comment on ${originText}`}
      descriptionAddon={
        <div className='flex text-left text-sm text-gray-500'>
          <p className='flex items-baseline'>
            <b className='min-w-fit'>{userName}</b>
            <p className='mr-1 ml-1'>wrote:</p>
            <EditorText initialData={JSON.parse(message) as Content} editable={false} truncateText hasQuote />
          </p>
        </div>
      }
    />
  )
}
